mutation UpdatePost($id: ID!, $input: UpdatePostInput!) {
  updatePost(id: $id, input: $input) {
    id
    title
    description
    text
    slug
    organization {
      id
      title
    }
    image {
      id
      url(format: HIGH)
    }
    tags {
      id
      title
    }
    publishAt
    accessOnlyViaLink
    createdAt
    updatedAt
  }
}
